module.exports = __webpack_public_path__ + "img/company-logo.0bff1381.png";